/**
 * @generated SignedSource<<0ccb4a44535236c6c9ef2973c9fec88b>>
 * @relayHash 88c78c4472555f8fd5818cace9226cf2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 88c78c4472555f8fd5818cace9226cf2

import { ConcreteRequest } from 'relay-runtime';
export type RichTextWebPageMetadataByUrlQuery$variables = {
  url: string;
};
export type RichTextWebPageMetadataByUrlQuery$data = {
  readonly webPageMetadataByUrl: {
    readonly description: string | null;
    readonly embedUrl: string | null;
    readonly id: string;
    readonly openGraphImage: {
      readonly uid: string;
    } | null;
    readonly title: string | null;
  } | null;
};
export type RichTextWebPageMetadataByUrlQuery = {
  response: RichTextWebPageMetadataByUrlQuery$data;
  variables: RichTextWebPageMetadataByUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "url",
    "variableName": "url"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "embedUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RichTextWebPageMetadataByUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WebPageMetadata",
        "kind": "LinkedField",
        "name": "webPageMetadataByUrl",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContraImage",
            "kind": "LinkedField",
            "name": "openGraphImage",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RichTextWebPageMetadataByUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WebPageMetadata",
        "kind": "LinkedField",
        "name": "webPageMetadataByUrl",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContraImage",
            "kind": "LinkedField",
            "name": "openGraphImage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "88c78c4472555f8fd5818cace9226cf2",
    "metadata": {},
    "name": "RichTextWebPageMetadataByUrlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0d375a83430ee0764604f1fb12f51bd5";

export default node;
